export default __webpack_public_path__ + "static/media/metamask-network-kovan.fbaca7ba.png";